import {Component, Input, OnInit} from '@angular/core';
import {
    MenuItemsInterface, SidebarMetadataInterface,
    SidebarNavService
} from "@app/shared/cs-components/sidebar-nav/services/sidebar-nav.service";
import {TranslateService} from "@ngx-translate/core";
import {WorkflowDataInterface} from "@app/workflow-common/services/workflow-observable.service";
import {INodeOptions} from "@app/workflow-common/diagram-view2/models/node.model";

@Component({
  selector: 'app-automation-audit',
  templateUrl: './automation-audit.component.html',
  styles: []
})
export class AutomationAuditComponent implements OnInit {

    @Input() activeMenuId: string = 'workflow_instanceHistory';
    @Input() settingsTypeId: number;
    @Input() screenName: string;
    @Input() workflowData: WorkflowDataInterface = undefined;
    @Input() dagRunId: any = undefined;
    @Input() metaData: any;

    currentActiveMenuItem: MenuItemsInterface = {id: "", status: undefined, title: "", visible: false};
    sidebarMetadata: SidebarMetadataInterface;
    nodeOptions: INodeOptions;

    constructor(
        private _translate: TranslateService,
        public sidebarNavService: SidebarNavService,
    ) { }

   ngOnInit() {
       this.setSidebarMeta();
       this.sidebarNavService.setDefaultSelectedId(this.activeMenuId);
       this.sidebarNavService.setMetadata(this.sidebarMetadata);
   }

    setSidebarMeta(stepsStatus:any = undefined) {
        this.sidebarMetadata = {
            showProgressBar: false,
            groups: [{
                id: 'grp_history',
                title: 'History'
            }],
            items: [
                {
                    id: 'workflow_instanceHistory',
                    title: this._translate.instant('Workflow history'),
                    status: 'in_progress',
                    visible: true,
                    groupId: 'grp_history',
                    selected: true,
                    iconClass: 'fa-solid fa-clock-rotate-left'
                },
                {
                    id: 'workflow_auditHistory',
                    title: this._translate.instant('Workflow audit'),
                    status: 'in_progress',
                    visible: true,
                    groupId: 'grp_history',
                    iconClass: 'fas fa-file-search'
                },
                {
                    id: 'workflow_audit2',
                    title: this._translate.instant('Workflow audit'),
                    status: 'in_progress',
                    visible: true,
                    groupId: 'grp_history2'
                },
            ]
        };
    }

    setCurrentActiveItem(e) {
        this.currentActiveMenuItem = e;
    }

}
